export default __webpack_public_path__ + "static/media/inbellezza.15274761.png";